import { render, staticRenderFns } from "./device06-a-dianji.vue?vue&type=template&id=2a070c88&"
import script from "./device06-a-dianji.vue?vue&type=script&lang=js&"
export * from "./device06-a-dianji.vue?vue&type=script&lang=js&"
import style0 from "./device06-a-dianji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports